import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HeaderMenu } from "@wine2trace/ui/HeaderShell";
import useLabels from "../../hooks/useLabels";
import { selectWineries } from "../../context/selectors";
import { empty } from "../../context/operations/operationsSlice";
import { emptyExp } from "../../context/expOperations/expOperationsSlice";
import { emptyAnalysis } from "../../context/protocols/analysisSlice";
import { emptyUsers } from "../../context/users/usersSlice";
import { emptyExams } from "../../context/substances/examsSlice";
import { emptyTanks } from "../../context/tanks/tanksSlice";
import { emptyLots } from "../../context/lots/lotsSlice";
import { emptyApplications } from "../../context/protocols/applicationSlice";
import { setActive } from "../../context/wineries/wineriesSlice";
import { setUserRbac } from "../../context/user/userSlice";

// Centre of the header: the active winery and, when the user can work on more than one, a dropdown
// with the others. Choosing one drops everything loaded for the old winery (pages may refer to
// records of the other one) and lands on the Home; permissions are fetched again for the new winery.
const WinerySwitcher = ({ activeWinery, canSwitch, locale }) => {
  const [getLabel] = useLabels();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const wineries = useSelector(selectWineries);

  const others = [...(wineries || [])]
    .filter((winery) => winery?.id !== activeWinery?.id)
    .sort((a, b) => String(a.name).localeCompare(String(b.name), locale, { sensitivity: "base" }));

  const switchTo = (winery) => {
    [empty, emptyExp, emptyAnalysis, emptyUsers, emptyExams, emptyTanks, emptyLots, emptyApplications].forEach(
      (clear) => dispatch(clear())
    );
    dispatch(setActive(winery));
    dispatch(setUserRbac({}));
    navigate("/");
  };

  return (
    <>
      <span className="header_wrapper_center_text">{activeWinery?.name}</span>
      {canSwitch && others.length > 0 && (
        <HeaderMenu className="header_winery_menu" label={getLabel("settingsChangeWinery")}>
          {others.map((winery) => (
            <button key={winery.id} type="button" className="header_menu_item" onClick={() => switchTo(winery)}>
              {winery.name}
            </button>
          ))}
        </HeaderMenu>
      )}
    </>
  );
};

export default WinerySwitcher;
